import { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTable, { fmtDate } from "../components/DataTable";
import { apiCall } from "../auth/AuthContext";

const avg = (a, b, c) => {
  const xs = [a, b, c].filter((v) => typeof v === "number");
  return xs.length ? Math.round(xs.reduce((s, x) => s + x, 0) / xs.length) : null;
};

export default function AdminCredit() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const d = await apiCall("/api/admin/credit"); setRecords(d.records || []); }
      catch { setRecords([]); }
      finally { setLoading(false); }
    })();
  }, []);

  const enriched = records.map((r) => ({
    ...r,
    "Starting Score Average": avg(r["Starting Score EQ"], r["Starting Score EX"], r["Starting Score TU"]),
    "Current Score Average": avg(r["Current Score EQ"], r["Current Score EX"], r["Current Score TU"]),
  }));

  const columns = [
    { key: "Name", label: "Client", sortable: true },
    { key: "Starting Score Average", label: "Start Avg" },
    { key: "Current Score Average", label: "Now Avg" },
    {
      key: "Score Gain", label: "Gain", sortable: true,
      fmt: (v) => typeof v === "number" ? (
        <span className={v > 0 ? "text-emerald-300 font-semibold" : v < 0 ? "text-red-300" : "text-jc-muted"}>{v > 0 ? `+${v}` : v}</span>
      ) : "—"
    },
    { key: "Dispute Round", label: "Round" },
    { key: "Items Removed", label: "Removed" },
    { key: "Last Updated", label: "Updated", fmt: fmtDate },
    { key: "Credit Status", label: "Status" },
  ];

  return (
    <AdminLayout title="CREDIT PIPELINE" kicker="Score Trajectories">
      <DataTable
        testId="admin-credit-table"
        loading={loading}
        records={enriched}
        columns={columns}
        searchKeys={["Name", "Credit Status"]}
        emptyText="No credit advisory records yet."
        initialSort={{ key: "Score Gain", dir: "desc" }}
      />
    </AdminLayout>
  );
}
